// Audit event model. Automations in this prototype are always visible and
// reviewable, so every meaningful transition records a plain-language event.

export const AUDIT_ACTION = {
  DRAFT_CREATED: 'Draft created',
  TEMPLATE_SELECTED: 'Template selected',
  TEMPLATE_APPLIED: 'Template applied',
  TEMPLATE_INSTANTIATED: 'Template instantiated',
  REQUEST_AUTOSAVED: 'Request autosaved',
  REQUEST_SUBMITTED: 'Request submitted',
  REQUEST_RETURNED: 'Request returned',
  TRIAGE_ACCEPTED: 'Accepted for assessment',
  REQUEST_REJECTED: 'Request rejected',
  DUPLICATE_LINKED: 'Duplicate linked',
  CHANGE_ID_GENERATED: 'Change ID generated',
  CHANGE_MANAGER_ASSIGNED: 'Change manager assigned',
  ASSESSOR_FUNCTION_ADDED: 'Assessor function added',
  ASSESSOR_FUNCTION_REMOVED: 'Assessor function removed',
  ASSESSMENT_TASK_CREATED: 'Assessment task created',
  CONTAINMENT_TASK_CREATED: 'Containment task created',
  FIELD_CHANGED: 'Field changed',
  SAVE_FAILED_RETRY_SUCCEEDED: 'Save failed and retry succeeded',
  // Assessment and approval events (prompt Part 9).
  ASSESSMENT_INSTANTIATED: 'Assessment instantiated from template',
  PREFILLED_ANSWER_EDITED: 'Template-prefilled answer edited',
  SUGGESTED_ANSWER_CONFIRMED: 'Suggested answer confirmed',
  SUGGESTED_ANSWER_CHANGED: 'Suggested answer changed',
  SECTION_COMPLETED: 'Section completed',
  SECTION_REOPENED: 'Completed section reopened',
  AFFECTED_OBJECT_ACCEPTED: 'Candidate affected object accepted',
  AFFECTED_OBJECT_REJECTED: 'Candidate affected object rejected',
  ASSESSMENT_SUBMITTED: 'Assessment submitted',
  APPROVAL_ROUTE_CALCULATED: 'Approval route calculated',
  ASSESSMENT_RETURNED: 'Assessment returned for revision',
  APPROVAL_SIGNED: 'Assessment approval signed',
  APPROVAL_WITH_CONDITIONS_SIGNED: 'Approval with conditions signed',
  ASSESSMENT_REJECTED: 'Assessment rejected',
  SIGNED_BASELINE_CREATED: 'Signed baseline created',
  DRAFT_PLANNING_ITEMS_GENERATED: 'Draft planning items generated',
  TEMPLATE_CUSTOM_FIELD_ADDED: 'Template custom field added',
  // Implementation plan and execution events (Screens 7 and 8).
  PLAN_CREATED: 'Plan created from approved assessment',
  TASK_ADDED: 'Task added',
  TASK_REMOVED: 'Task removed',
  TASK_OWNER_CHANGED: 'Task owner changed',
  TASK_DUE_DATE_CHANGED: 'Task due date changed',
  TASK_UPDATED: 'Task updated',
  PLAN_EXECUTION_STARTED: 'Plan execution started',
  TASK_STARTED: 'Task started',
  TASK_COMPLETED: 'Task completed',
  NEW_IMPACT_REPORTED: 'New impact reported',
  REASSESSMENT_REQUESTED: 'Reassessment requested',
  PLAN_AMENDMENT_CREATED: 'Plan amendment created',
  COMPLETION_STARTED: 'Completion started',
  RELEASE_READINESS_CHECKED: 'Release readiness checked',
  RELEASE_APPROVED: 'Release approved',
  EFFECTIVENESS_REVIEW_COMPLETED: 'Effectiveness review completed',
  CHANGE_CLOSED: 'Change closed',
} as const;
export type TAuditAction = (typeof AUDIT_ACTION)[keyof typeof AUDIT_ACTION];

export type TAuditEvent = {
  id: string;
  timestamp: string;
  actor: string;
  action: TAuditAction;
  description: string;
};
